// import Navbar from './Components/Navbar/Navbar';
import { Route, Routes } from 'react-router-dom';
import Home from './Components/Home/Home.jsx';
import Blog from './pages/Blog/Blog.jsx';
import NotFound from './pages/NotFound/NotFound.jsx';
import 'aos/dist/aos.css';

// import About from './pages/About/About.jsx';
// // import Skill from './pages/Skill/Skill.jsx';
// import Service from './pages/Servicess/Service.jsx';
// import Portfolio from './pages/Portfolio/Portfolio.jsx';
// import Contact from './pages/Contact/Contact.jsx';
function App() {
  return (
    <>
      {/* <Home /> */}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
